import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useNavigate } from "react-router-dom";

import logo_img from "../../../New_Web_design/W_Logo.png";
export default function Navbars() {
  const [expanded, setExpanded] = useState(false);
  const [scrollValue, setSrollValue] = React.useState();
  const navToggle = () => {
    setExpanded(expanded ? false : true);
  };
  const closeNav = () => {
    setExpanded(false);
    setToggle(true);
  };

  const handleScroll = () => {
    setTab1(false);
    setTab2(false);
    setTab3(false);
    setTab4(false);
    setTab5(false);
    const scrollPosition = window.scrollY;
    setSrollValue(scrollPosition);
  };
  console.log("scrollValue::: ", scrollValue);
  useEffect(() => {
    // handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      handleScroll();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const history = useNavigate();
  const [toggle, setToggle] = React.useState(true);
  const [tab1, setTab1] = React.useState(false);
  const [tab2, setTab2] = React.useState(false);
  const [tab3, setTab3] = React.useState(false);
  const [tab4, setTab4] = React.useState(false);
  const [tab5, setTab5] = React.useState(false);
  const [tab6, setTab6] = React.useState(false);

  return (
    <div>
      <Navbar
        className="blurNavbar"
        expand="lg"
        fixed="top"
        expanded={expanded}
        style={{
          backgroundColor:
            window.location.pathname.split("/")[1] == "TermsAndConditions" ||
            window.location.pathname.split("/")[1] == "Faq" ||
            window.location.pathname.split("/")[1] == "ReturnPolicy" ||
            window.location.pathname.split("/")[1] == "Blog" ||
            window.location.pathname.split("/")[1] == "Blog" ||
            window.location.pathname.split("/")[1] == "Privacy" ||
            window.location.pathname.split("/")[1] == "FairplayPolicy" ||
            scrollValue >= 20
              ? ""
              : "#0e121c",
        }}
      >
        <div className="container">
          <Navbar.Brand
            href="#home"
            onClick={() => history("/")}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              alt=""
              style={{ width: "55px" }}
              src={logo_img}
              className="d-inline-block align-top navWidthHeight"
            />

            <div>
              <p
                className="sub-header mb-0 px-2"
                style={{
                  fontFamily: "NunitoBlack",
                  color: "white",
                  zIndex: 1,
                  lineHeight: "37px",
                }}
              >
                WolfW<span class="i">i</span>n
              </p>
              <p
                className="px-2 mb-0"
                style={{
                  fontFamily: "NunitoBoldItalic",
                  color: "#929498",
                  fontSize: "15px",
                }}
              >
                Skill Up - Cash Out
              </p>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={navToggle}>
            {toggle ? (
              <>
                {" "}
                <div onClick={() => setToggle(!toggle)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="white"
                    class="bi bi-text-paragraph"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"
                    />
                  </svg>
                </div>
              </>
            ) : (
              <>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="white"
                    class="bi bi-text-paragraph"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"
                    />
                  </svg>
                </div>
              </>
            )}
          </Navbar.Toggle>
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end"
          >
            <Nav>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={navToggle}
              >
                {toggle ? (
                  <></>
                ) : (
                  <>
                    <div
                      onClick={() => setToggle(!toggle)}
                      style={{ display: "flex", justifyContent: "start" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="white"
                        class="bi bi-x"
                        viewBox="0 0 16 16"
                      >
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                      </svg>
                    </div>
                  </>
                )}
              </Navbar.Toggle>
              <Nav.Link
                style={{
                  fontSize: "16px",
                  marginRight: "12px",
                  color:
                    tab1 || scrollValue <= 440
                      ? window.location.pathname.split("/")[1] ==
                          "TermsAndConditions" ||
                        window.location.pathname.split("/")[1] == "Faq" ||
                        window.location.pathname.split("/")[1] ==
                          "ReturnPolicy" ||
                        window.location.pathname.split("/")[1] == "Blog" ||
                        window.location.pathname.split("/")[1] == "Privacy" ||
                        window.location.pathname.split("/")[1] ==
                          "FairplayPolicy"
                        ? "#4d4f54"
                        : "#f9c130"
                      : "#4d4f54",
                }}
                className="text-center"
                onClick={() => {
                  history("/");
                  setTab1(true);
                  setTab2(false);
                  setTab3(false);
                  setTab4(false);
                  setTab5(false);
                  setTab6(false);

                  closeNav();
                  window.scrollTo(0, 0);
                }}
              >
                <b>Home</b>
                <div
                  class="underline mt-1"
                  style={{
                    backgroundColor:
                      tab1 || scrollValue <= 440
                        ? window.location.pathname.split("/")[1] ==
                            "TermsAndConditions" ||
                          window.location.pathname.split("/")[1] == "Faq" ||
                          window.location.pathname.split("/")[1] ==
                            "ReturnPolicy" ||
                          window.location.pathname.split("/")[1] == "Blog" ||
                          window.location.pathname.split("/")[1] == "Privacy" ||
                          window.location.pathname.split("/")[1] ==
                            "FairplayPolicy"
                          ? ""
                          : "#f9c130"
                        : "transparent",
                  }}
                ></div>
              </Nav.Link>
              <Nav.Link
                href="#"
                style={{
                  color:
                    window.location.pathname.split("/")[1] == "Blog"
                      ? "#f9c130"
                      : "#4d4f54",
                  fontSize: "16px",
                  marginRight: "12px",
                }}
                className="text-center"
                onClick={() => {
                  history("/Blog");
                  setTab1(false);
                  setTab2(false);
                  setTab3(false);
                  setTab4(false);
                  setTab5(false);
                  setTab6(true);
                  closeNav();
                }}
              >
                <b>Blog</b>
                <div
                  class="underline mt-1"
                  style={{
                    backgroundColor:
                      window.location.pathname.split("/")[1] == "Blog"
                        ? "#f9c130"
                        : "",
                  }}
                ></div>
              </Nav.Link>
              <Nav.Link
                href="#Games"
                style={{
                  color:
                    tab2 || (scrollValue >= 440 && scrollValue <= 1500)
                      ? window.location.pathname.split("/")[1] ==
                          "TermsAndConditions" ||
                        window.location.pathname.split("/")[1] == "Faq" ||
                        window.location.pathname.split("/")[1] ==
                          "ReturnPolicy" ||
                        window.location.pathname.split("/")[1] == "Blog" ||
                        window.location.pathname.split("/")[1] == "Privacy" ||
                        window.location.pathname.split("/")[1] ==
                          "FairplayPolicy"
                        ? "#4d4f54"
                        : "#f9c130"
                      : "#4d4f54",
                  fontSize: "16px",
                  marginRight: "12px",
                }}
                className="text-center"
                onClick={() => {
                  history("/");
                  setTab1(false);
                  setTab2(true);
                  setTab3(false);
                  setTab4(false);
                  setTab5(false);
                  setTab6(false);

                  closeNav();
                }}
              >
                <b>Games</b>
                <div
                  class="underline mt-1"
                  style={{
                    backgroundColor:
                      tab2 || (scrollValue >= 440 && scrollValue <= 1500)
                        ? window.location.pathname.split("/")[1] ==
                            "TermsAndConditions" ||
                          window.location.pathname.split("/")[1] == "Faq" ||
                          window.location.pathname.split("/")[1] ==
                            "ReturnPolicy" ||
                          window.location.pathname.split("/")[1] == "Blog" ||
                          window.location.pathname.split("/")[1] == "Privacy" ||
                          window.location.pathname.split("/")[1] ==
                            "FairplayPolicy"
                          ? ""
                          : "#f9c130"
                        : "transparent",
                  }}
                ></div>
              </Nav.Link>
              <Nav.Link
                href="#win"
                style={{
                  color:
                    tab3 || (scrollValue >= 1500 && scrollValue <= 5190)
                      ? window.location.pathname.split("/")[1] ==
                          "TermsAndConditions" ||
                        window.location.pathname.split("/")[1] == "Faq" ||
                        window.location.pathname.split("/")[1] ==
                          "ReturnPolicy" ||
                        window.location.pathname.split("/")[1] == "Blog" ||
                        window.location.pathname.split("/")[1] == "Privacy" ||
                        window.location.pathname.split("/")[1] ==
                          "FairplayPolicy"
                        ? "#4d4f54"
                        : "#f9c130"
                      : "#4d4f54",
                  fontSize: "16px",
                  marginRight: "12px",
                }}
                className="text-center"
                onClick={() => {
                  history("/");
                  setTab1(false);
                  setTab2(false);
                  setTab3(true);
                  setTab4(false);
                  setTab5(false);
                  setTab6(false);

                  closeNav();
                }}
              >
                <b>Win</b>
                <div
                  class="underline mt-1"
                  style={{
                    backgroundColor:
                      tab3 || (scrollValue >= 1500 && scrollValue <= 5190)
                        ? window.location.pathname.split("/")[1] ==
                            "TermsAndConditions" ||
                          window.location.pathname.split("/")[1] == "Faq" ||
                          window.location.pathname.split("/")[1] ==
                            "ReturnPolicy" ||
                          window.location.pathname.split("/")[1] == "Blog" ||
                          window.location.pathname.split("/")[1] == "Privacy" ||
                          window.location.pathname.split("/")[1] ==
                            "FairplayPolicy"
                          ? ""
                          : "#f9c130"
                        : "transparent",
                  }}
                ></div>
              </Nav.Link>
              <Nav.Link
                href="#About"
                style={{
                  color:
                    tab4 || (scrollValue >= 5190 && scrollValue <= 5500)
                      ? window.location.pathname.split("/")[1] ==
                          "TermsAndConditions" ||
                        window.location.pathname.split("/")[1] == "Faq" ||
                        window.location.pathname.split("/")[1] ==
                          "ReturnPolicy" ||
                        window.location.pathname.split("/")[1] == "Blog" ||
                        window.location.pathname.split("/")[1] == "Privacy" ||
                        window.location.pathname.split("/")[1] ==
                          "FairplayPolicy"
                        ? "#4d4f54"
                        : "#f9c130"
                      : "#4d4f54",
                  fontSize: "16px",
                  marginRight: "12px",
                }}
                className="text-center"
                onClick={() => {
                  history("/");
                  setTab1(false);
                  setTab2(false);
                  setTab3(false);
                  setTab4(true);
                  setTab5(false);
                  setTab6(false);
                  closeNav();
                }}
              >
                <b>About</b>
                <div
                  class="underline mt-1"
                  style={{
                    backgroundColor:
                      tab4 || (scrollValue >= 5190 && scrollValue <= 5500)
                        ? window.location.pathname.split("/")[1] ==
                            "TermsAndConditions" ||
                          window.location.pathname.split("/")[1] == "Faq" ||
                          window.location.pathname.split("/")[1] ==
                            "ReturnPolicy" ||
                          window.location.pathname.split("/")[1] == "Blog" ||
                          window.location.pathname.split("/")[1] == "Privacy" ||
                          window.location.pathname.split("/")[1] ==
                            "FairplayPolicy"
                          ? ""
                          : "#f9c130"
                        : "transparent",
                  }}
                ></div>
              </Nav.Link>
              <Nav.Link
                href="#contact"
                style={{
                  color:
                    tab5 || (scrollValue >= 5500 && scrollValue <= 6000)
                      ? window.location.pathname.split("/")[1] ==
                          "TermsAndConditions" ||
                        window.location.pathname.split("/")[1] == "Faq" ||
                        window.location.pathname.split("/")[1] ==
                          "ReturnPolicy" ||
                        window.location.pathname.split("/")[1] == "Blog" ||
                        window.location.pathname.split("/")[1] == "Privacy" ||
                        window.location.pathname.split("/")[1] ==
                          "FairplayPolicy"
                        ? "#4d4f54"
                        : "#f9c130"
                      : "#4d4f54",
                  fontSize: "16px",
                  marginRight: "12px",
                }}
                className="text-center"
                onClick={() => {
                  history("/");
                  setTab1(false);
                  setTab2(false);
                  setTab3(false);
                  setTab4(false);
                  setTab5(true);
                  setTab6(false);
                  closeNav();
                }}
              >
                <b>Contact</b>
                <div
                  class="underline mt-1"
                  style={{
                    backgroundColor:
                      tab5 || (scrollValue >= 5500 && scrollValue <= 6000)
                        ? window.location.pathname.split("/")[1] ==
                            "TermsAndConditions" ||
                          window.location.pathname.split("/")[1] == "Faq" ||
                          window.location.pathname.split("/")[1] ==
                            "ReturnPolicy" ||
                          window.location.pathname.split("/")[1] == "Blog" ||
                          window.location.pathname.split("/")[1] == "Privacy" ||
                          window.location.pathname.split("/")[1] ==
                            "FairplayPolicy"
                          ? ""
                          : "#f9c130"
                        : "transparent",
                  }}
                ></div>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
      {!toggle && (
        <div
          id="overlay"
          style={{
            height: 10450,

            backdropFilter: "blur(8px)",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 1001,
          }}
        />
      )}
    </div>
  );
}
